import { isDateBetween, getTimeRemaining } from '@app/datetime';

import {
  BLACKFRIDAY_END,
  BLACKFRIDAY_START,
  BLACKFRIDAY_COUNTDOWN_START,
} from '../consts';

/**
 * Function to find the current running phase of the blackfriday - Pre/Live/Post
 */
export const selectBlackFridayPhase = () => {
  // Black friday archive
  return null;

  const currentTime = new Date();
  const countdownStart = new Date(BLACKFRIDAY_COUNTDOWN_START);
  const bfStart = new Date(BLACKFRIDAY_START);
  const bfEnd = new Date(BLACKFRIDAY_END);

  if (isDateBetween(currentTime, countdownStart, bfStart)) {
    return 'Pre';
  }

  if (isDateBetween(currentTime, bfStart, bfEnd)) {
    return 'Live';
  }

  if (getTimeRemaining(currentTime, bfEnd).total < 0) {
    return 'Post';
  }

  // Not started
  return null;
};

/**
 *
 * @param currentPhase
 */
export const durationUntilNextPhase = (currentPhase) => {
  if (!currentPhase) {
    return null;
  }

  let duration = null as any;

  if (currentPhase === 'Pre') {
    duration = getTimeRemaining(new Date(), new Date(BLACKFRIDAY_START));
  }

  if (currentPhase === 'Live') {
    duration = getTimeRemaining(new Date(), new Date(BLACKFRIDAY_END));
  }

  if (duration) {
    return {
      days: duration.days,
      hours: duration.hours,
      minutes: duration.minutes,
      seconds: duration.seconds,
    };
  }

  // Ended
  return null;
};
